import type { SetupContext } from 'vue'
import type { IToolingBaseComposableDataItem } from '../use-tooling-base/types'
import type {
  IToolingFormComposable,
  IToolingFormComposableProps,
  IToolingFormComposableViewData,
} from './types'
import { watch } from 'vue'
import { computedFn } from './computed'
import { dataFn } from './data'
import { methodsFn } from './methods'

export const useToolingForm = <DataItemType extends IToolingBaseComposableDataItem>(
  props: IToolingFormComposableProps,
  ctx: SetupContext,
  viewData: IToolingFormComposableViewData,
): IToolingFormComposable<DataItemType> => {
  const data = dataFn<DataItemType>()

  const computed = computedFn<DataItemType>(props, ctx, { ...data, ...viewData })

  const methods = methodsFn<DataItemType>(props, ctx, { ...data, ...viewData, ...computed })

  watch(
    () => data.item.value.criteria.pivots,
    pivots => {
      data.pivotable.value = pivots ?? []
    },
  )

  return {
    ...data,
    ...computed,
    ...methods,
  }
}

export * from './types'
